import { render, staticRenderFns } from "./ProductAdmin.vue?vue&type=template&id=3c515704&scoped=true"
import script from "./ProductAdmin.vue?vue&type=script&lang=js"
export * from "./ProductAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProductAdmin.vue?vue&type=style&index=0&id=3c515704&prod&lang=scss"
import style1 from "./ProductAdmin.vue?vue&type=style&index=1&id=3c515704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c515704",
  null
  
)

export default component.exports